<template>
  <div class="loading-placeholder">
    <div class="skeleton" v-for="n in rows" :key="n" :style="{ height: height + 'px' }"></div>
  </div>
</template>

<script>
export default {
  name: "list-skeleton",
  props: {
    rows: { type: Number, default: 3 },
    height: { type: Number, default: 50 }
  }
};
</script>
